module.exports = __webpack_public_path__ + "img/copy-outline.0f9349ab.svg";